import Head from 'next/head';
import { Document } from '@contentful/rich-text-types';
import { documentToHtmlString } from '@contentful/rich-text-html-renderer';
import type { Faq } from '@zoopla/cms/types';

interface CmsFaqSchemaProps {
    faqs: Faq[];
}

export function generateAnswerSchema(faqs: Faq[]) {
    return faqs.map((faq: Faq) => {
        const author = faq?.author
            ? {
                  author: {
                      '@type': 'Person',
                      name: faq.author.authorName,
                      url: `https://www.zoopla.co.uk/discover/meet-the-team/${faq.author.authorSlug}/`
                  }
              }
            : {};

        return {
            '@type': 'Question',
            name: faq.question,
            acceptedAnswer: {
                '@type': 'Answer',
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                text: documentToHtmlString(faq.answer as Document),
                ...author
            }
        };
    });
}

export function CmsFaqSchema({ faqs }: CmsFaqSchemaProps) {
    const faqSchema = {
        '@context': 'https://schema.org',
        '@type': 'FAQPage',
        mainEntity: generateAnswerSchema(faqs)
    };

    return (
        <Head>
            <script
                type="application/ld+json"
                dangerouslySetInnerHTML={{
                    __html: JSON.stringify(faqSchema)
                }}
            />
        </Head>
    );
}
